import Link from "next/link";
import type { ReactNode } from "react";
import { CONTACT_EMAIL } from "@/lib/config";

export const LEGAL_LINK_CLASS = "text-blue-500 underline";

export function legalRichValues() {
  return { contactEmail: CONTACT_EMAIL };
}

export function createLegalRichTags() {
  return {
    strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
    guidelines: (chunks: ReactNode) => (
      <Link href="/community-guidelines" className={LEGAL_LINK_CLASS}>
        {chunks}
      </Link>
    ),
    terms: (chunks: ReactNode) => (
      <Link href="/terms" className={LEGAL_LINK_CLASS}>
        {chunks}
      </Link>
    ),
    privacy: (chunks: ReactNode) => (
      <Link href="/privacy" className={LEGAL_LINK_CLASS}>
        {chunks}
      </Link>
    ),
    website: (chunks: ReactNode) => (
      <a href="https://kraahl.com" target="_blank" rel="noopener noreferrer" className={LEGAL_LINK_CLASS}>
        {chunks}
      </a>
    ),
    mail: (chunks: ReactNode) => (
      <a href={`mailto:${CONTACT_EMAIL}`} className={LEGAL_LINK_CLASS}>
        {chunks}
      </a>
    ),
  };
}
